import React from 'react';
import { createComponent } from '@lit/react';
import { IxRadio as IxRadioLit } from '../IxRadio.js';

customElements.define('ix-button', IxRadioLit);

export const IxButton = createComponent({
  tagName: 'ix-radio-react',
  elementClass: IxRadioLit,
  react: React,
  events: {
    onclick: 'onClick',
    onkeydown: 'keydown',
  },
});
